import { Title as SectionTitle } from "./Title";
import { Description as SectionDescription } from "./Description";
import { CSSProperties, FC, PropsWithChildren, ReactNode } from "react";
import clsx from "clsx";
import { ColorKeys } from "@/theme/colors";
import { TypographyKeys } from "@/theme/typography";
import "./Section.scss";

type SectionProps = PropsWithChildren<{
  className?: string;
  style?: CSSProperties;
}>;

interface SectionComponent extends FC<SectionProps> {
  Title: typeof SectionTitle;
  Description: typeof SectionDescription;
}

const Section: SectionComponent = ({
  className,
  children,
  style,
}: SectionProps) => {
  return (
    <section className={className} style={style}>
      {children}
    </section>
  );
};

interface SeactionHeadingProps {
  className?: string;
  titleMarginBottom?: string;
  descriptionMarginBottom?: string;
  descriptionClassName?: string;
  title?: string | ReactNode;
  titleId?: string;
  mdFs?: TypographyKeys;
  fs?: TypographyKeys;
  color?: ColorKeys;
  description?: string | ReactNode;
  children?: ReactNode;
}

const SectionHeading = ({
  className,
  title,
  titleId,
  color = "primary",
  titleMarginBottom = "mb-x16",
  descriptionClassName = "",
  descriptionMarginBottom = "mb-x40",
  description,
  children,
  mdFs = "2",
  fs = "4",
}: SeactionHeadingProps) => {
  return (
    <>
      {title && (
        <div
          className={clsx(
            "ui-sections__title d-flex gap-x16",
            titleMarginBottom,
            className,
          )}
        >
          <SectionTitle
            id={titleId}
            fs={fs}
            mdFs={mdFs}
            as={"h2"}
            color={color}
          >
            {title}
          </SectionTitle>
          {children}
        </div>
      )}
      {description && (
        <SectionDescription
          className={clsx(
            "ui-sections__description",
            descriptionMarginBottom,
            descriptionClassName,
          )}
        >
          {description}
        </SectionDescription>
      )}
    </>
  );
};

Section.Title = SectionTitle;
Section.Description = SectionDescription;

export { Section, SectionHeading };
